import { render, staticRenderFns } from "./Circoscrizioni.vue?vue&type=template&id=40dcce9c&"
import script from "./Circoscrizioni.vue?vue&type=script&lang=js&"
export * from "./Circoscrizioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports